import React from 'react';
import NotificationContainer from './NotificationWidget';
import { widget } from '@widgets/core';
import NotificationStore from './store';
export var NotificationWidget = widget('notification')(function () { return new NotificationStore; }, function (store, tracker) {
    if (store.config.useService && store.request.state === "pending")
        return null;
    return (React.createElement(NotificationContainer, { notifications: store.notifications, closeNotification: store.closeNotification, tracker: tracker, onWidgetMounted: store.props.onWidgetMounted }));
});
export default NotificationWidget;
